import * as S from "./styles";

export const SubTitle = ({ children }) => {
  return <S.SubTitle>{children}</S.SubTitle>;
};
